import { ReactNode } from 'react'

import { BlankSlate, Box, Text } from '@factorialco/deprecated-design-system'
import {
  ProjectionKind,
  usePerformanceCyclesDataTable,
} from 'generated/resources/datatable.graphql'
import { DocumentNode } from 'graphql'
import moment from 'moment'

import DataTable from 'modules/core/components/DataTable'
import i18n from 'modules/core/lib/i18n'

import { Actions } from './Actions'

export const PerformanceCyclesTable: React.FC<{
  actions?: ReactNode
  refetchQueries?: DocumentNode[]
}> = ({ actions, refetchQueries = [] }) => {
  const source = usePerformanceCyclesDataTable([
    {
      identifier: 'title',
      title: i18n.t('performance_goals.create_key_results_modal.fields.title'),
      kind: ProjectionKind.Custom,
      template: '{{ title }}',
      colSpan: 2,
      render: ({ title }) => {
        return <Text.Normal>{title}</Text.Normal>
      },
    },
    {
      identifier: 'start_on',
      title: i18n.t('performance_goals.create_key_results_modal.fields.start_on'),
      fixed: true,
      kind: ProjectionKind.Custom,
      template: '{{ startOn }}',
      colSpan: 2,
      render: ({ startOn }) => {
        return <Text.Normal>{moment(startOn).format('D MMM YYYY')}</Text.Normal>
      },
    },
    {
      identifier: 'end_on',
      title: i18n.t('performance_goals.create_key_results_modal.fields.end_on'),
      fixed: true,
      kind: ProjectionKind.Custom,
      template: '{{ startOn }}',
      colSpan: 2,
      render: ({ endOn }) => {
        return <Text.Normal>{moment(endOn).format('D MMM YYYY')}</Text.Normal>
      },
    },
    {
      identifier: 'actions',
      kind: ProjectionKind.Decorative,
      width: 100,
      fixed: true,
      render: (cycle) => {
        return <Actions cycle={cycle} refetchQueries={refetchQueries} />
      },
    },
  ])

  return (
    <Box gap="s32">
      <DataTable
        source={source}
        disableEditColumns
        disableExport
        actions={actions}
        emptyState={
          <BlankSlate
            illustration="analytics-graph-lines"
            size="small"
            title={i18n.t('performance_goals.cycles.blank_state.title')}
            description={i18n.t('performance_goals.cycles.blank_state.description')}
          />
        }
      />
    </Box>
  )
}
